/* ---------------------------------------------------------------------------
 * Copyright (c) 2020 - Watt-IS
 *
 * Project:    pme_app
 * File:       app/javascript/packs/application.js
 * Creator:    Pedro Major <pmajor@watt-is.com>
 * Created:    2020-09-23
 *
 * Propose:    Web Application entry point
 * ------------------------------------------------------------------------ */

/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Support component names relative to this directory:
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

import '../stylesheets/application.scss';
import "@fortawesome/fontawesome-free/css/all.css";


import Rails from '@rails/ujs';
Rails.start();

/* import Turbolinks from 'turbolinks'
 * Turbolinks.start()
 * console.info('turbolinks started');
 *  */

///////////////////////////////////////////////////////////////////////////////
// Legacy Codebase Support
///////////////////////////////////////////////////////////////////////////////
import 'jquery/src/jquery';
import 'bootstrap';
import 'icheck/icheck.js';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js';

window.$ = jQuery;
window.jQuery = jQuery;

import 'metismenu/dist/metisMenu.js'; // inspina req
import 'jquery-slimscroll';
import 'jquery-tooltip/jquery.tooltip.js';
import 'jquery-popover/dist/jquery-popover-0.0.3.js';
import 'bootstrap-daterangepicker/daterangepicker.js';
import 'bootstrap-daterangepicker/daterangepicker.css';

import { combineReducers, createStore } from 'redux';
const Redux = { combineReducers, createStore };
window.Redux = Redux;

import moment from 'moment/moment.js';
window.moment = moment;
///////////////////////////////////////////////////////////////////////////////

console.log('application[JS] ready!');
